<div id="wrap">
  <div class="preadesao">
    <h1>Criar Nova Senha</h1>
    @if (!concluido) {
      <div class="box adesao">
        <form [formGroup]="form">
          <div class="form-group full-width">
            <input type="password" formControlName="senha" placeholder="Senha" />
            @if (!this.form.get('senha').valid && (this.form.get('senha').touched || this.form.get('senha').dirty)) {
              <div>
                @if (form.get('senha').hasError('required')) {
                  <small class="text-danger">
                    Campo Obrigatório
                  </small>
                }
                @if (form.get('senha').hasError('minlength')) {
                  <small class="text-danger">
                    A senha deve conter no mínimo 8 caracteres
                  </small>
                }
              </div>
            }
          </div>
          <div class="form-group full-width">
            <input type="password" formControlName="senhaConfirmacao" placeholder="Confirmação da Senha" (input)="validarSenhaConfirmacao()"/>
            @if (msgConfNovaSenha!=null) {
              <div class="text-danger">
                {{msgConfNovaSenha}}
              </div>
            }
          </div>
          <div class="text-danger text-center full-width erro-servidor" [ngStyle]="{'visibility': msgErro==null ? 'hidden' : 'visible' }">
            {{msgErro}}
          </div>
          <button type="submit" class="btn_verde" [disabled]="!form.valid || loading" (click)="salvar()">
            SALVAR  @if (loading) {
            <i class="fas fa-spinner fa-spin"></i>
          }
        </button>
      </form>
    </div>
  }

  @if (concluido) {
    <div class="alert alert-success text-center" role="alert">
      Email enviado com sucesso
    </div>
  }
</div>
</div>